import { render, staticRenderFns } from "./CollapseDivTwo.vue?vue&type=template&id=3046852d&"
import script from "./CollapseDivTwo.vue?vue&type=script&lang=js&"
export * from "./CollapseDivTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports